/**
 * BST + accessiBe — open widget from custom buttons and navigation menu links.
 *
 * Menu link URL (Online Store → Navigation): use #accessibility
 * Example: Link = #accessibility, Name = Accessibility
 */
(function () {
  'use strict';

  const MENU_LINK_HASHES = ['#accessibility', '#open-accessibility', '#acsb'];

  function isAccessibilityMenuLink(anchor) {
    if (!anchor || anchor.tagName !== 'A') return false;

    const href = (anchor.getAttribute('href') || '').trim().toLowerCase();
    const hash = (anchor.hash || '').toLowerCase();

    if (MENU_LINK_HASHES.includes(hash)) return true;
    if (MENU_LINK_HASHES.includes(href)) return true;

    return false;
  }

  function openWidget(trigger) {
    if (typeof window.acsbJS !== 'undefined') {
      if (typeof window.acsbJS.open === 'function') {
        window.acsbJS.open();
        return true;
      }
      if (typeof window.acsbJS.openMainWindow === 'function') {
        window.acsbJS.openMainWindow();
        return true;
      }
    }

    if (trigger && trigger.getAttribute('data-acsb-custom-trigger') === 'true') {
      trigger.click();
      return true;
    }

    const builtIn = document.querySelector('.acsb-trigger');
    if (builtIn) {
      builtIn.click();
      return true;
    }

    return false;
  }

  window.bstOpenAccessibilityWidget = openWidget;

  function onAccessibilityClick(event) {
    const trigger = event.target.closest('[data-bst-accessibility-trigger]');
    if (trigger) {
      event.preventDefault();
      openWidget(trigger);
      return;
    }

    const menuLink = event.target.closest('a[href]');
    if (!menuLink || !isAccessibilityMenuLink(menuLink)) return;

    event.preventDefault();
    openWidget(menuLink);
  }

  document.addEventListener('click', onAccessibilityClick);
  window.addEventListener('bst:accessibility-open', () => openWidget());
})();
